import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreActions } from 'easy-peasy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { EditRounded, FileCopy } from '@material-ui/icons';
import { ErrorMessage } from 'formik';
import _e from 'common/localeUtil';
import { getFullSubdomainURL, MESSAGE_TYPES } from '../utils';
import EditUrlDialog from './dialog/EditUrlDialog';
import { EditorLeftPanelContext } from './EditorLeftPanelContext';

const useStyles = makeStyles(theme => ({
	wrapperStyle: {
		marginBottom: theme.spacing(1),
		paddingRight: theme.spacing(1),
		'& .section-title': {
			marginBottom: theme.spacing(1)
		}
	},
	form: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'stretch',
		border: `1px solid #365275`,
		paddingLeft: theme.spacing(1),
		paddingBottom: theme.spacing(0),
		'& .error': {
			display: 'none'
		}
	},
	formError: {
		color: '#ff453a'
	},
	copyToClipboard: {
		margin: '0 10px',
		backgroundColor: theme.palette.primary['400']
	},
	urlStyle: {
		display: 'flex',
		flex: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		lineClamp: 1,
		'-webkit-line-clamp': 1,
		textOverflow: 'ellipsis',
		minHeight: 30,
		alignItems: 'center',
		fontWeight: '1rem'
	},
	submitButton: {
		background: 'none',
		color: 'white !important'
	},
	iconStyle: {
		width: 30,
		height: 30,
		minWidth: 0,
		borderRadius: 0,
		margin: 0,
		borderLeft: '1px solid #365275',
		background: theme.palette.primary['100'],
		color: theme.palette.text.primary,
		'&:hover': {
			background: theme.palette.primary['200']
		}
	}
}));

const EditorLeftPanelURL = ({ subdomain: defaultSubdomain }) => {
	const context = useContext(EditorLeftPanelContext);
	const { formik } = context;
	const classes = useStyles();
	const [subdomain, setSubdomain] = useState(defaultSubdomain);
	const [editMode, setEditMode] = useState(false);
	const showMessage = useStoreActions(actions => actions.showMessage.showMessage);
	const [fullWebsiteURL, setFullWebsiteURL] = useState(getFullSubdomainURL(subdomain));

	useEffect(() => {
		setFullWebsiteURL(getFullSubdomainURL(subdomain));
	}, [subdomain]);

	const handleSubdomainChanged = async newSubdomain => {
		setSubdomain(newSubdomain);
		setFullWebsiteURL(getFullSubdomainURL(newSubdomain));
		formik.setFieldValue('subdomain', newSubdomain);
	};

	useEffect(() => {
		// console.log('EditorLeftPanelURL useEffect', { defaultSubdomain, subdomain });
		if (defaultSubdomain !== subdomain) {
			handleSubdomainChanged(defaultSubdomain);
		}
	});

	const showEditor = () => {
		setEditMode(true);
	};
	const closeDialog = () => {
		setEditMode(false);
	};

	const doCopy = () => {
		window.gm_track(`Copy subdomain clicked`, { fullWebsiteURL });

		showMessage({ text: _e('link_copied'), type: MESSAGE_TYPES.LINKCOPIED });
	};

	// console.log('Full Website URL', fullWebsiteURL);
	return (
		<div className={classes.wrapperStyle}>
			{/*<div className="section-title">URL</div>*/}
			<div className={classes.form}>
				<div className={classes.urlStyle}>
					{/* eslint-disable-next-line react/no-unescaped-entities */}
					{`${subdomain}.${process.env.REACT_APP_SITE_URL}`}
				</div>
				<CopyToClipboard text={fullWebsiteURL} onCopy={doCopy}>
					<Button onCopy={doCopy} classes={{ root: classes.iconStyle }}>
						<FileCopy style={{ width: 15, height: 15 }} />
					</Button>
				</CopyToClipboard>
				<Button
					id={`edit-url-button`}
					onClick={showEditor}
					classes={{ root: classes.iconStyle }}
				>
					<EditRounded style={{ width: 18, height: 18 }} />
				</Button>
			</div>
			<ErrorMessage name="subdomain">
				{msg => <div className={classes.formError}>{msg}</div>}
			</ErrorMessage>
			{
				<EditUrlDialog
					defaultSubdomain={subdomain}
					title={_e('edit_url')}
					handleClose={closeDialog}
					handleChanged={handleSubdomainChanged}
					open={editMode}
				/>
			}
		</div>
	);
};

EditorLeftPanelURL.propTypes = {
	subdomain: PropTypes.string
	// openLinkedInDialog: PropTypes.bool.isRequired,
	// setOpenLinkedInDialog: PropTypes.func.isRequired
};

export default EditorLeftPanelURL;
